export interface CalibrationDelivery_Interface {
    id: number,
    code: string,
    customer_name: string,
    customer_id: number,
    inperson: string,
    username: string,
    subdate: string,
}

export function Empty_CalibrationDelivery_Interface(): CalibrationDelivery_Interface {
    return {
        id: 0,
        code: '',
        customer_id: 0,
        customer_name: '',
        inperson: '',
        username: '',
        subdate: '',
    }
}